import { render, staticRenderFns } from "./numbergrow.vue?vue&type=template&id=34384654&scoped=true"
import script from "./numbergrow.vue?vue&type=script&lang=js"
export * from "./numbergrow.vue?vue&type=script&lang=js"
import style0 from "./numbergrow.vue?vue&type=style&index=0&id=34384654&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34384654",
  null
  
)

export default component.exports